import { ErrorMessage, Input } from '@/components';
import {
  Controller,
  type FieldErrors,
  type FieldValues,
  type Path,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Form } from '.';
import { FieldLabel } from './FieldLabel';
import type { FormControlProp } from './types';

type Props<T extends FieldValues> = {
  control: FormControlProp<T>;
  name: Path<T>;
  label: string;
  placeholder?: string;
  errors: FieldErrors;
  required?: boolean;
  showHint?: boolean;
};

export const PasswordField = <T extends FieldValues>({
  name,
  label,
  placeholder,
  control,
  errors,
  required,
  showHint,
}: Props<T>) => {
  const { t } = useTranslation();
  return (
    <Form.Item
      label={
        label && (
          <FieldLabel
            text={label}
            required={required}
            hint={showHint ? t('hint-password-policy') : undefined}
          />
        )
      }
    >
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Input.Password placeholder={placeholder} {...field} />
        )}
      />
      <ErrorMessage errors={errors} name={name} />
    </Form.Item>
  );
};
